import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e81861b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SaveLoad = _resolveComponent("SaveLoad")!
  const _component_RollDice = _resolveComponent("RollDice")!
  const _component_LanguageChanger = _resolveComponent("LanguageChanger")!
  const _component_CharactersTabs = _resolveComponent("CharactersTabs")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SaveLoad),
      _hoisted_3,
      _createVNode(_component_RollDice),
      _createVNode(_component_LanguageChanger)
    ]),
    _createVNode(_component_CharactersTabs)
  ]))
}